export const URL_POST_USER_LOGIN = '/api/authservice/Login';
export const URL_GET_USER_INFO = '/api/userservice/GetUserInfo';
// Marks the intro walkthrough (CANapps Home Tour) as seen for the current user.
export const URL_COMPLETE_INTRO = '/api/userservice/CompleteIntro';
export const URL_GET_DISPATCH_CUSTOMERS =
	'/api/candispatchv3/SearchDispatchCustomers?payload={"SearchKeyword":"","Page":1,"Take":2147483647}';
export const URL_GET_ADDRESSES =
	'api/candispatchv3/SearchAddresses?payload={"Id":0,"SearchKeyword":"","Page":1,"Take":1000,"CustomerId":"336"';
export const URL_GET_USER = '/api/userservice/GetUser?payload={"id":';
export const URL_GET_USER_API = '/api/userservice/GetUserApi?payload={"id":';
export const URL_GET_USERS =
	'/api/userservice/GetUsers?payload={"Id":0,"SearchKeyword":"","Page":1,"Take":1000}';
export const URL_GET_USERS_API = '/api/userservice/GetUsersApi';
export const URL_GET_COMPANIES =
	'/api/cantrackv3/SCustomersMulti?id=141&SearchKeyword=&Page=1&Take=1000&Ids=141';
export const URL_GET_CONTACT = '/api/cantrackv3/ReadContact?id=';
export const URL_GET_CONTACT_API = '/api/cantrackv3/GetContact?id=';
export const URL_GET_CONTACTS = '/api/ContactController/ReadContacts';
export const URL_GET_CONTACTS_FOR_CUSTOMER = '/api/ContactController/GetContactsForCustomer?customerId=';
export const URL_GET_CONTACT_LIST = '/api/cantrackv3/GetContacts';
export const URL_GET_ALL_CONTACTS = '/api/userservice/GetAllContacts';
export const URL_GET_CONTACT_TYPES =
	'/api/cantrackv3/SContactTypes?payload={"Id":0,"SearchKeyword":"","Page":1,"Take":141}';
export const URL_GET_ROLES =
	'/api/cantrackv3/SUserRoles?payload={%22Id%22:0,%22SearchKeyword%22:%22%22,%22Page%22:1,%22Take%22:141}';
export const URL_GET_LANGUAGE_TYPES = '/api/cantrackv3/SLanguageTypes';
export const URL_CREATE_CONTACT = '/api/cantrackv3/ApiCreateContact';
export const URL_BULK_CREATE_CONTACTS = '/api/cantrackv3/ApiBulkCreateContacts';
export const URL_UPLOAD_FILE = '/api/fileuploadservice/Upload';
export const URL_DOWNLOAD_FILE = '/api/fileuploadservice/Download?FileId=';
export const URL_PREVIEW_FILE = '/api/fileuploadservice/Preview?FileId=';
export const URL_DELETE_FILE = '/api/fileuploadservice/Delete?FileId=';
export const URL_UPDATE_CONTACT = '/api/cantrackv3/ApiUpdateContact';
export const URL_GET_CANTAB = '/api/cantabs/GetCanTabApi';
export const URL_GET_CANTABS = '/api/cantabs/GetCanTabsApi';

export const URL_GET_ROLES_API = '/api/cantabs/GetRolesApi';
export const URL_GET_MENU_ROLES = '/api/cantabs/ReadRolesApi';
export const URL_GET_MENU_CANTABS = '/api/cantabs/ReadCanTabsApi';
export const URL_GET_MENU_ADMIN_CANTABS = '/api/cantabs/ReadCanAdminTabsApi';

export const URL_CREATE_MENU_TAB = '/api/cantabs/CreateTabApi';
export const URL_DELETE_MENU_TAB = '/api/cantabs/DeleteTabApi';
export const URL_LOGOUT = '/Portal/admin/Logoff.aspx';
export const URL_GET_ROLEGROUP = '/api/userservice/GetRoleGroupApi';
export const URL_GET_USER_GROUP = '/api/userservice/GetUserGroupApi';

/** Menu Page */
export const URL_GET_MENU = '/api2.0/Menu/GetMenuApi';
export const URL_UPDATE_MENU_TAB = '/api2.0/Menu/UpdateTabApi';
export const URL_UPDATE_MENU_SUBTAB = '/api2.0/Menu/UpdateSubTabApi';
export const URL_UPDATE_MENU_ROLE = '/api2.0/Menu/UpdateRoleApi';

/**
 * @desc - User Service
 */
export const URL_GET_USER_ROLE_GROUPS_API = '/api/userservice/GetUserGroupsApi';
export const URL_CREATE_USER = '/api/userservice/CreateUser';
export const URL_CREATE_USER_API = '/api/userservice/CreateUserApi';
export const URL_UPDATE_USER = '/api/userservice/UpdateUser';
export const URL_UPDATE_USER_API = '/api/userservice/UpdateUserApi';

/**
 * @desc - Folder Permissions APIs
 */
export const URL_GET_ALL_FOLDERS = '/api/userservice/GetAllFolders';
export const URL_GET_USER_FOLDER_PERMISSIONS = '/api/userservice/GetUserFolderPermissions?userId=';
export const URL_SET_USER_FOLDER_PERMISSIONS = '/api/userservice/SetUserFolderPermissions';

export const URL_ARCHIVE_CONTACT = '/api/cantrackv3/ArchiveContact';

/**
 * CANDispatch Scheduler APIs (legacy — used by ReadSchedule, GetSchedulesByDateRange)
 */
export const URL_SCHEDULER_READ = '/api/candispatch/ReadSchedule';
export const URL_SCHEDULER_READ_DATE_RANGE = '/api/candispatch/GetSchedulesByDateRange';
export const URL_SCHEDULER_CREATE = '/api/candispatch/CreateSchedule';
export const URL_SCHEDULER_DELETE = '/api/candispatch/DeleteScheduleAssignment';
export const URL_SCHEDULER_BY_GUARD = '/api/candispatch/GetScheduleByGuard';
export const URL_SCHEDULER_BY_ADDRESS = '/api/candispatch/GetScheduleByAddress';

/**
 * Scheduler V4 — Granular patrol CRUD (Node.js backend)
 */
export const URL_SCHEDULER_V4_PATROLS = '/api3.2/scheduler/patrols';
export const URL_SCHEDULER_V4_PATROLS_BULK = '/api3.2/scheduler/patrols/bulk';

/**
 * CANDispatch Search APIs
 */
export const URL_SEARCH_CUSTOMERS = '/api/candispatchv3/SearchDispatchCustomers';
export const URL_SEARCH_ADDRESSES = '/api/candispatchv3/SearchAddresses';

/**
 * CANTrack Contact Search (for guards/employees)
 */
export const URL_SEARCH_CONTACTS = '/api/cantrackv3/SContactTypeEmployees';

/**
 * CANTrack Customer Management APIs
 */
export const URL_CANTRACK_READ_CUSTOMERS = '/api/cantrackv3/ReadCustomers';
export const URL_CANTRACK_READ_CUSTOMER = '/api/cantrackv3/ReadCustomer';
export const URL_CANTRACK_CREATE_CUSTOMER = '/api/cantrackv3/CreateCustomer';
export const URL_CANTRACK_UPDATE_CUSTOMER = '/api/cantrackv3/UpdateCustomer';
export const URL_CANTRACK_SEARCH_CUSTOMER_TYPES = '/api/cantrackv3/SCustomerTypes';

/**
 * CANDispatch Address Management APIs
 */
export const URL_CANDISPATCH_READ_ADDRESSES = '/api/candispatchv3/ReadAddresses';
export const URL_CANDISPATCH_READ_ADDRESS = '/api/candispatchv3/ReadAddress';
export const URL_CANDISPATCH_CREATE_ADDRESS = '/api/candispatchv3/CreateAddress';
export const URL_CANDISPATCH_UPDATE_ADDRESS = '/api/candispatchv3/UpdateAddress';
export const URL_CANTRACK_SEARCH_ADDRESS_TYPES = '/api/cantrackv3/SAddressTypes';

/**
 * CANtrack Cases APIs
 */
export const URL_CANTRACK_READ_CASES = '/api/cantrackv3/ReadCases';
export const URL_CANTRACK_READ_CASE = '/api/cantrackv3/ReadCase';
export const URL_CANTRACK_CREATE_CASE = '/api/cantrackv3/CreateCase';
export const URL_CANTRACK_UPDATE_CASE = '/api/cantrackv3/UpdateCase';
export const URL_CANTRACK_REMOVE_CASE = '/api/cantrackv3/RemoveCase';

/**
 * CANtrack Keywords APIs
 */
export const URL_CANTRACK_READ_KEYWORDS = '/api/cantrackv3/ReadKeywords';
export const URL_CANTRACK_CREATE_KEYWORD = '/api/cantrackv3/CreateKeyword';
export const URL_CANTRACK_UPDATE_KEYWORD = '/api/cantrackv3/UpdateKeyword';
export const URL_CANTRACK_DELETE_KEYWORD = '/api/cantrackv3/DeleteKeyword';

/**
 * CANtrack Payroll APIs
 */
export const URL_CANTRACK_GET_PAYROLL_REPORT = '/api/cantrackv3/GetPayrollReport';
export const URL_CANTRACK_GET_CUT_OFF_HOUR = '/api/cantrackv3/GetCutOffHour';
